import React from 'react';
import LocalizationService from "./LocalizationService";

const LocalizationContext = React.createContext({
  translate: (...rest) => LocalizationService.translate(...rest),

});

export default LocalizationContext;



// WEBPACK FOOTER //
// ./src/logic/localization/LocalizationContext.js